// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"238":"416cbbb4","453":"eb4b5cec"}[chunkId] + ".chunk.js";
};